export const handleClickGoBack = (history) => {
    history.goBack();
};

export const handleClickGoHome = (history, locale) => {
    history.push(`/${locale}/`);
};
